import {POST} from "@/services/gateway";
import {trimString} from "@/components/common/utils/trimString";

const listGroupmetadata = ({teamIds, folderId, snapshotDateTime, pagination, searchTerm}) => {
  return POST('recovery/team/groupmetadata/search', {
    teamIds,
    folderId,
    snapshotDateTime,
    pagination,
    searchTerm: trimString(searchTerm),
  })
}

const getGroupmetadata = ({teamIds, folderId, snapshotDateTime, pagination, searchTerm, metadataType, selectedIds}) => {
  return POST('recovery/team/groupmetadata/view', {
    teamIds,
    folderId,
    snapshotDateTime,
    pagination,
    metadataType,
    selectedIds,
    searchTerm: trimString(searchTerm),
  })
}

const listBreadcrumps = ({teamId, folderId, snapshotDate}) => {
  return POST('recovery/team/groupmetadata/breadcrumbs', {teamId, folderId, snapshotDate})
}

const exportSnapshot = ({
                          snapshotDateTime,
                          sourceIds,
                          searchTerm,
                          grouppropertyterm,
                          folderId,
                          selectedIds,
                          extension,
                          code,
                          storageDestinationId,
                          dataType,
                          storageDestinationType
                        }) => {
  return POST('recovery/team/groupmetadata/export', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    grouppropertyterm,
    folderId,
    selectedIds,
    extension,
    storageDestinationId,
    dataType,
    storageDestinationType
  }, {code: code ? code : null})
}

const restoreSnapshot = ({
                           snapshotDateTime,
                           sourceIds,
                           searchTerm,
                           destinationId,
                           snapshotId,
                           RestoreType,
                           grouppropertyterm,
                           folderId,
                           selectedIds,
                           code,
                         }) => {
  return POST('recovery/team/groupmetadata/restore', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    destinationId,
    snapshotId,
    RestoreType,
    grouppropertyterm,
    folderId,
    selectedIds
  }, {code: code ? code : null})
}

export {
  listGroupmetadata,
  getGroupmetadata,
  listBreadcrumps,
  exportSnapshot,
  restoreSnapshot
}
